export const parseList = (value: unknown): Array<string> => {
    if (Array.isArray(value)) return value.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
    if (typeof value !== 'string' || value.trim().length === 0) return []

    try {
        const parsed: unknown = JSON.parse(value)

        return Array.isArray(parsed)
            ? parsed.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
            : []
    }
    catch {
        return []
    }
}

export const toBoolean = (value: unknown): boolean => value === 1 || value === true || value === '1'

export const normalizeText = (value: string): string =>
    value
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim()

export const digitsOnly = (value: string): string => value.replace(/\D/g, '')

export const whatsappHref = (phone: string | null | undefined, message?: string): string | null => {
    if (!phone) return null

    const digits = digitsOnly(phone)

    if (digits.length < 8) return null

    const text = message ? `?text=${encodeURIComponent(message)}` : ''

    return `https://wa.me/${digits}${text}`
}

export const telHref = (phone: string | null | undefined): string | null => {
    if (!phone) return null

    const cleaned = phone.replace(/[^\d+]/g, '')

    return cleaned.length >= 7 ? `tel:${cleaned}` : null
}

export const mailHref = (email: string | null | undefined): string | null =>
    email && email.includes('@') ? `mailto:${email}` : null

export const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
